import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CoreLink,
  RecursiveMenu,
  Webform,
} from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { useSelector } from 'react-redux';
import { SocialMenu, WebformNewsletterAction } from '../../../components';
import { ReactComponent as UncIncLogo } from '../../../assets/images/UncIncLogo.svg';
import { ReactComponent as BCorpLogo } from '../../../assets/images/BCorpLogo.svg';
import { ReactComponent as ISO9001Logo } from '../../../assets/images/ISO9001Logo.svg';
import { ReactComponent as ISO27001Logo } from '../../../assets/images/ISO27001Logo.svg';
import { ReactComponent as DDALogo } from '../../../assets/images/DDALogo.svg';

import './style.scss';

const FooterMenu = () => {
  const { t } = useTranslation();
  const lang = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
  const about = lang === 'nl' ? 'over-ons' : 'about-us';


  return (
    <div className="FooterMenu">
      <Container>
        <div className="FooterMenu__wrapper">
          <div className="FooterMenu__wrapper__columns">
            <UncIncLogo className="UncIncLogo" />
            <RecursiveMenu
              menuId="footer"
              maxLevel={2}
            />
            <RecursiveMenu
              menuId="contact"
              maxLevel={2}
            />
            <div className="FooterMenu__newsletter">
              <h4>{t('footer.newsletter')}</h4>
              <Webform id="newsletter" overriddenComponents={{ webform_actions: WebformNewsletterAction }} />
            </div>
          </div>
        </div>
      </Container>

      <div className="FooterMenu__separator" />

      <Container>
        <div className="FooterMenu__certificates">
          <CoreLink title="iso9001" href={`/${lang}/${about}/iso-9001`}><ISO9001Logo className="Certification" /></CoreLink>
          <CoreLink title="iso-27001" href={`/${lang}/${about}/dda`}><DDALogo className="Certification" /></CoreLink>
          <CoreLink title="b-corp" href={`/${lang}/${about}/b-corp`}><BCorpLogo className="Certification" /></CoreLink>
          <CoreLink title="dutch digital agencies" href={`/${lang}/${about}/iso-27001`}><ISO27001Logo className="Certification" /></CoreLink>
        </div>
      </Container>

      <div className="FooterMenu__separator" />

      <Container>
        <div className="FooterMenu__bottom">
          <RecursiveMenu menuId="legal" maxLevel={1} />
          <SocialMenu colorClass="white" showHeader={false} />
        </div>
      </Container>
    </div>
  );
};

export default FooterMenu;
